import BOTTOM_SHEETS from 'components/bottomsheet/registry';
import { BottomSheet } from 'components/common/BottomSheet';
import useBottomSheet from 'hooks/common/useBottomSheet';

function BottomSheetRouter() {
  const { sheets } = useBottomSheet();

  return (
    <>
      {Object.keys(sheets).map((id) => {
        const sheet = sheets[id];
        const Content = BOTTOM_SHEETS[id];
        if (sheet.status === 'idle' || !Content) {
          return null;
        }

        // 등록 옵션은 store 가 열 때 호출부 옵션 아래에 합쳐 둔다
        const Component = Content.content;

        return (
          <BottomSheet key={`${id}:${sheet.openTime}`} id={id} sheet={sheet}>
            <Component />
          </BottomSheet>
        );
      })}
    </>
  );
}

export default BottomSheetRouter;
